import React from 'react'

import { useDispatch } from 'react-redux'

import {
  HowGoustoFoodBoxesWorkPage,
  MealPlanningPage,
  FoodBoxPage,
  FoodBoxCmsPage,
} from '@features/marketing-pages'
import { fetchCmsBlocks, FOOD_BOX_PAGE, useIsCmsBlocksEnabled } from '@library/cms-blocks'
import { fetchByUrl } from '@library/contentstack-client'

import { applyPromoCode } from 'actions/home'
import { redirect } from 'actions/redirect'
import { fetchCmsEntry } from 'apis/cms'

export function HowGoustoWorks() {
  const dispatch = useDispatch()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCode())

    dispatch(redirect(path))
  }

  return <HowGoustoFoodBoxesWorkPage startOnboarding={handleClick} />
}

export function MealPlanning() {
  const dispatch = useDispatch()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCode())

    dispatch(redirect(path))
  }

  return <MealPlanningPage startOnboarding={handleClick} />
}

export function FoodBox() {
  const dispatch = useDispatch()
  const isCmsBlocksEnabled = useIsCmsBlocksEnabled()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCode())

    dispatch(redirect(path))
  }

  return isCmsBlocksEnabled ? (
    <FoodBoxCmsPage startOnboarding={handleClick} cmsFetcher={fetchCmsEntry} />
  ) : (
    <FoodBoxPage startOnboarding={handleClick} />
  )
}

// SSR: pre-populate Redux for /food-box on every request, regardless of flag state.
// The flag only controls which UI variant renders; CMS data is always fetched server-side
// to avoid a content flash when the flag flips on.
FoodBox.fetchData = ({ store }: { store: { dispatch: (action: unknown) => unknown } }) =>
  store.dispatch(fetchCmsBlocks([FOOD_BOX_PAGE], fetchByUrl))
